export const LAUNCHDARKLY_USER_KEYS = {
  ANONYMOUS: 'anonymous_user',
  CYPRESS_TESTS: 'cypress_test_user'
};

export const FLAGS = {
  ENABLE_FRIEND_SUGGESTIONS_FOR_SUCCESS_VIEW:
    'enable-friend-suggestions-for-success-view',
  ENABLE_NEW_SIGN_UP_FLOW: 'enable-new-sign-up-flow',
  ENABLE_NEW_LOGIN_SCREEN: 'enable-new-login-screen',
  ENABLE_USER_REQUIREMENTS_ONBOARDING_API:
    'enable-user-requirements-onboarding-api',
  ENABLE_EMAIL_EDIT: 'enable-email-edit',
  ENABLE_AUTH_MIGRATION_FLOW: 'enable-auth-migration-flow',
  ENABLE_UNVERIFIED_EMAIL_VERIFICATION_ALERT:
    'enable-unverified-email-verification-alert',
  ENABLE_NOTIFICATION_REDESIGN: 'enable-notification-redesign',
  ENABLE_TAXES_IN_CHECKOUT: 'enable-taxes-in-checkout',
  ENABLE_TAXES_IN_EVENT_FORM: 'enable-taxes-in-event-form',
  ENABLE_TIERS_DISCOUNT_CODES: 'enable-tiers-discount-codes',
  ENABLE_GROUPS_AS_HOST: 'enable-groups-as-host',
  ENABLE_GROUPS: 'enable-groups',
  ENABLE_FEATURE_REMINDERS: 'enable-feature-reminders',
  ENABLE_CONFETTI_VIEW: 'enable-confetti-view',
  ENABLE_BOUNCE_BRANDED_QR_CODES: 'enable-bounce-branded-qr-codes',
  ENABLE_EVENT_FEES_BREAKDOWN: 'enable-event-fees-breakdown',
  ENABLE_BUY_MORE_TICKETS: 'enable-buy-more-tickets',
  ENABLE_MANAGE_TICKET_SCANNERS: 'enable-manage-ticket-scanners',
  ENABLE_TIMEBOUND_TIERS: 'enable-timebound-tiers',
  ENABLE_EVENT_WAIVER: 'enable-event-waiver',
  ENABLE_EVENT_ORGANIZER_FEE: 'enable-event-organizer-fee',
  ENABLE_SAVE_AND_PUBLISH_EVENTS: 'enable-save-and-publish-events',
  ENABLE_EVENT_BULK_PHOTO_UPLOAD: 'enable-event-bulk-photo-upload',
  ENABLE_RECURRING_EVENTS: 'enable-recurring-events',
  ENABLE_EVENT_LOG: 'enable-event-log',
  ENABLE_NEW_EVENT_DASHBOARD: 'enable-new-event-dashboard',
  ENABLE_PROMOTER_OFFERS: 'enable-promoter-offers',
  ENABLE_BOUNCE_BLAST: 'enable-bounce-blast',
  ENABLE_CSV_EXPORT: 'enable-csv-export',
  ENABLE_ASSOCIATION_TOPN_SEGMENT_ANALYTICS:
    'enable-association-topn-segment-analytics',
  ENABLE_ORGANIZATION_TOPN_SEGMENT_ANALYTICS:
    'enable-organization-topn-segment-analytics',
  ENABLE_ORG_EVENTS: 'enable-org-events',
  ENABLE_ORGANIZATION_TITLES: 'enable-organization-titles',
  ENABLE_EVENT_MOMENTUM_CHIP: 'enable-event-momentum-chip',
  ENABLE_TRANSLATIONS: 'enable-translations',
  ENABLE_ASSOCIATION_WORKFLOWS: 'enable-association-workflows',
  ENABLE_ORG_MEMBERSHIPS: 'enable-org-memberships',
  ENABLE_PHONE_VERIFICATION_MODAL: 'enable-phone-verification-modal',
  ENABLE_ORG_DISCOUNT_CODES: 'enable-org-discount-codes',
  ENABLE_OTP_EMAIL_LOGIN: 'enable-otp-email-login'
};
